/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CompleteRouteImport } from './routes/complete'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as InterviewTokenRouteImport } from './routes/interview/$token'
import { Route as DevErrorRouteImport } from './routes/dev.error'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminOrganizationsIndexRouteImport } from './routes/_authenticated/admin/organizations/index'
import { Route as AuthenticatedOrgOrgSlugWorkflowIndexRouteImport } from './routes/_authenticated/org/$orgSlug/workflow/index'
import { Route as AuthenticatedOrgOrgSlugTeamIndexRouteImport } from './routes/_authenticated/org/$orgSlug/team/index'
import { Route as AuthenticatedOrgOrgSlugIntegrationsIndexRouteImport } from './routes/_authenticated/org/$orgSlug/integrations/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug'
import { Route as AuthenticatedAdminOrganizationsOrgIdDepartmentsRouteImport } from './routes/_authenticated/admin/organizations/$orgId/departments'
import { Route as AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRouteImport } from './routes/_authenticated/org/$orgSlug/integrations/teamtailor/index'
import { Route as AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRouteImport } from './routes/_authenticated/org/$orgSlug/integrations/recman/index'
import { Route as AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRouteImport } from './routes/_authenticated/org/$orgSlug/integrations/logicmelon/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/jobs/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/communications/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/communications/$type'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/jobs/new/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/jobs/import/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/index'
import { Route as AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRouteImport } from './routes/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/index'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteRoute = CompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InterviewTokenRoute = InterviewTokenRouteImport.update({
  id: '/interview/$token',
  path: '/interview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DevErrorRoute = DevErrorRouteImport.update({
  id: '/dev/error',
  path: '/dev/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedOrgOrgSlugWorkflowIndexRoute =
  AuthenticatedOrgOrgSlugWorkflowIndexRouteImport.update({
    id: '/org/$orgSlug/workflow/',
    path: '/org/$orgSlug/workflow/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugTeamIndexRoute =
  AuthenticatedOrgOrgSlugTeamIndexRouteImport.update({
    id: '/org/$orgSlug/team/',
    path: '/org/$orgSlug/team/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugIntegrationsIndexRoute =
  AuthenticatedOrgOrgSlugIntegrationsIndexRouteImport.update({
    id: '/org/$orgSlug/integrations/',
    path: '/org/$orgSlug/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteImport.update({
    id: '/org/$orgSlug/department/$deptSlug',
    path: '/org/$orgSlug/department/$deptSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute =
  AuthenticatedAdminOrganizationsOrgIdDepartmentsRouteImport.update({
    id: '/organizations/$orgId/departments',
    path: '/organizations/$orgId/departments',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute =
  AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRouteImport.update({
    id: '/org/$orgSlug/integrations/teamtailor/',
    path: '/org/$orgSlug/integrations/teamtailor/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute =
  AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRouteImport.update({
    id: '/org/$orgSlug/integrations/recman/',
    path: '/org/$orgSlug/integrations/recman/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute =
  AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRouteImport.update({
    id: '/org/$orgSlug/integrations/logicmelon/',
    path: '/org/$orgSlug/integrations/logicmelon/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRouteImport.update(
    {
      id: '/communications/',
      path: '/communications/',
      getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
    } as any,
  )
const AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRouteImport.update(
    {
      id: '/communications/$type',
      path: '/communications/$type',
      getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
    } as any,
  )
const AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRouteImport.update({
    id: '/jobs/new/',
    path: '/jobs/new/',
    getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRouteImport.update({
    id: '/jobs/import/',
    path: '/jobs/import/',
    getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRouteImport.update({
    id: '/jobs/$jobId/',
    path: '/jobs/$jobId/',
    getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
  } as any)
const AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRouteImport.update(
    {
      id: '/jobs/$jobId/$applicationId/',
      path: '/jobs/$jobId/$applicationId/',
      getParentRoute: () => AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/complete': typeof CompleteRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dev/error': typeof DevErrorRoute
  '/interview/$token': typeof InterviewTokenRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/organizations/$orgId/departments': typeof AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute
  '/org/$orgSlug/department/$deptSlug': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren
  '/org/$orgSlug/integrations/': typeof AuthenticatedOrgOrgSlugIntegrationsIndexRoute
  '/org/$orgSlug/team/': typeof AuthenticatedOrgOrgSlugTeamIndexRoute
  '/org/$orgSlug/workflow/': typeof AuthenticatedOrgOrgSlugWorkflowIndexRoute
  '/org/$orgSlug/integrations/logicmelon/': typeof AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute
  '/org/$orgSlug/integrations/recman/': typeof AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute
  '/org/$orgSlug/integrations/teamtailor/': typeof AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute
  '/org/$orgSlug/department/$deptSlug/communications/$type': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute
  '/org/$orgSlug/department/$deptSlug/communications/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/$jobId/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/import/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/new/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute
}
export interface FileRoutesByTo {
  '/complete': typeof CompleteRoute
  '/login': typeof LoginRoute
  '/dev/error': typeof DevErrorRoute
  '/interview/$token': typeof InterviewTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/organizations/$orgId/departments': typeof AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute
  '/org/$orgSlug/department/$deptSlug': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren
  '/org/$orgSlug/integrations': typeof AuthenticatedOrgOrgSlugIntegrationsIndexRoute
  '/org/$orgSlug/team': typeof AuthenticatedOrgOrgSlugTeamIndexRoute
  '/org/$orgSlug/workflow': typeof AuthenticatedOrgOrgSlugWorkflowIndexRoute
  '/org/$orgSlug/integrations/logicmelon': typeof AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute
  '/org/$orgSlug/integrations/recman': typeof AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute
  '/org/$orgSlug/integrations/teamtailor': typeof AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute
  '/org/$orgSlug/department/$deptSlug/communications/$type': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute
  '/org/$orgSlug/department/$deptSlug/communications': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/$jobId': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/import': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/new': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute
  '/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/complete': typeof CompleteRoute
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dev/error': typeof DevErrorRoute
  '/interview/$token': typeof InterviewTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/_authenticated/admin/organizations/$orgId/departments': typeof AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren
  '/_authenticated/org/$orgSlug/integrations/': typeof AuthenticatedOrgOrgSlugIntegrationsIndexRoute
  '/_authenticated/org/$orgSlug/team/': typeof AuthenticatedOrgOrgSlugTeamIndexRoute
  '/_authenticated/org/$orgSlug/workflow/': typeof AuthenticatedOrgOrgSlugWorkflowIndexRoute
  '/_authenticated/org/$orgSlug/integrations/logicmelon/': typeof AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute
  '/_authenticated/org/$orgSlug/integrations/recman/': typeof AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute
  '/_authenticated/org/$orgSlug/integrations/teamtailor/': typeof AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/communications/$type': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/communications/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/import/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/new/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute
  '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/': typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/complete'
    | '/login'
    | '/admin'
    | '/dev/error'
    | '/interview/$token'
    | '/admin/'
    | '/jobs/'
    | '/settings/'
    | '/admin/organizations/'
    | '/admin/organizations/$orgId/departments'
    | '/org/$orgSlug/department/$deptSlug'
    | '/org/$orgSlug/integrations/'
    | '/org/$orgSlug/team/'
    | '/org/$orgSlug/workflow/'
    | '/org/$orgSlug/integrations/logicmelon/'
    | '/org/$orgSlug/integrations/recman/'
    | '/org/$orgSlug/integrations/teamtailor/'
    | '/org/$orgSlug/department/$deptSlug/communications/$type'
    | '/org/$orgSlug/department/$deptSlug/communications/'
    | '/org/$orgSlug/department/$deptSlug/jobs/'
    | '/org/$orgSlug/department/$deptSlug/jobs/$jobId/'
    | '/org/$orgSlug/department/$deptSlug/jobs/import/'
    | '/org/$orgSlug/department/$deptSlug/jobs/new/'
    | '/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/complete'
    | '/login'
    | '/dev/error'
    | '/interview/$token'
    | '/'
    | '/admin'
    | '/jobs'
    | '/settings'
    | '/admin/organizations'
    | '/admin/organizations/$orgId/departments'
    | '/org/$orgSlug/department/$deptSlug'
    | '/org/$orgSlug/integrations'
    | '/org/$orgSlug/team'
    | '/org/$orgSlug/workflow'
    | '/org/$orgSlug/integrations/logicmelon'
    | '/org/$orgSlug/integrations/recman'
    | '/org/$orgSlug/integrations/teamtailor'
    | '/org/$orgSlug/department/$deptSlug/communications/$type'
    | '/org/$orgSlug/department/$deptSlug/communications'
    | '/org/$orgSlug/department/$deptSlug/jobs'
    | '/org/$orgSlug/department/$deptSlug/jobs/$jobId'
    | '/org/$orgSlug/department/$deptSlug/jobs/import'
    | '/org/$orgSlug/department/$deptSlug/jobs/new'
    | '/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/complete'
    | '/login'
    | '/_authenticated/admin'
    | '/dev/error'
    | '/interview/$token'
    | '/_authenticated/'
    | '/_authenticated/admin/'
    | '/_authenticated/jobs/'
    | '/_authenticated/settings/'
    | '/_authenticated/admin/organizations/'
    | '/_authenticated/admin/organizations/$orgId/departments'
    | '/_authenticated/org/$orgSlug/department/$deptSlug'
    | '/_authenticated/org/$orgSlug/integrations/'
    | '/_authenticated/org/$orgSlug/team/'
    | '/_authenticated/org/$orgSlug/workflow/'
    | '/_authenticated/org/$orgSlug/integrations/logicmelon/'
    | '/_authenticated/org/$orgSlug/integrations/recman/'
    | '/_authenticated/org/$orgSlug/integrations/teamtailor/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/communications/$type'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/communications/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/import/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/new/'
    | '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CompleteRoute: typeof CompleteRoute
  LoginRoute: typeof LoginRoute
  DevErrorRoute: typeof DevErrorRoute
  InterviewTokenRoute: typeof InterviewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete': {
      id: '/complete'
      path: '/complete'
      fullPath: '/complete'
      preLoaderRoute: typeof CompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/interview/$token': {
      id: '/interview/$token'
      path: '/interview/$token'
      fullPath: '/interview/$token'
      preLoaderRoute: typeof InterviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/error': {
      id: '/dev/error'
      path: '/dev/error'
      fullPath: '/dev/error'
      preLoaderRoute: typeof DevErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/organizations/': {
      id: '/_authenticated/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/org/$orgSlug/workflow/': {
      id: '/_authenticated/org/$orgSlug/workflow/'
      path: '/org/$orgSlug/workflow'
      fullPath: '/org/$orgSlug/workflow/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugWorkflowIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/team/': {
      id: '/_authenticated/org/$orgSlug/team/'
      path: '/org/$orgSlug/team'
      fullPath: '/org/$orgSlug/team/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugTeamIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/integrations/': {
      id: '/_authenticated/org/$orgSlug/integrations/'
      path: '/org/$orgSlug/integrations'
      fullPath: '/org/$orgSlug/integrations/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug'
      path: '/org/$orgSlug/department/$deptSlug'
      fullPath: '/org/$orgSlug/department/$deptSlug'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/organizations/$orgId/departments': {
      id: '/_authenticated/admin/organizations/$orgId/departments'
      path: '/organizations/$orgId/departments'
      fullPath: '/admin/organizations/$orgId/departments'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrgIdDepartmentsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/org/$orgSlug/integrations/teamtailor/': {
      id: '/_authenticated/org/$orgSlug/integrations/teamtailor/'
      path: '/org/$orgSlug/integrations/teamtailor'
      fullPath: '/org/$orgSlug/integrations/teamtailor/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/integrations/recman/': {
      id: '/_authenticated/org/$orgSlug/integrations/recman/'
      path: '/org/$orgSlug/integrations/recman'
      fullPath: '/org/$orgSlug/integrations/recman/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/integrations/logicmelon/': {
      id: '/_authenticated/org/$orgSlug/integrations/logicmelon/'
      path: '/org/$orgSlug/integrations/logicmelon'
      fullPath: '/org/$orgSlug/integrations/logicmelon/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/'
      path: '/jobs'
      fullPath: '/org/$orgSlug/department/$deptSlug/jobs/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/communications/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/communications/'
      path: '/communications'
      fullPath: '/org/$orgSlug/department/$deptSlug/communications/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/communications/$type': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/communications/$type'
      path: '/communications/$type'
      fullPath: '/org/$orgSlug/department/$deptSlug/communications/$type'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/new/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/new/'
      path: '/jobs/new'
      fullPath: '/org/$orgSlug/department/$deptSlug/jobs/new/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/import/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/import/'
      path: '/jobs/import'
      fullPath: '/org/$orgSlug/department/$deptSlug/jobs/import/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/'
      path: '/jobs/$jobId'
      fullPath: '/org/$orgSlug/department/$deptSlug/jobs/$jobId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
    '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/': {
      id: '/_authenticated/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/'
      path: '/jobs/$jobId/$applicationId'
      fullPath: '/org/$orgSlug/department/$deptSlug/jobs/$jobId/$applicationId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute: typeof AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminOrganizationsIndexRoute:
    AuthenticatedAdminOrganizationsIndexRoute,
  AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute:
    AuthenticatedAdminOrganizationsOrgIdDepartmentsRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteChildren {
  AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute
}

const AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteChildren: AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteChildren =
  {
    AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsTypeRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugCommunicationsIndexRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsIndexRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdIndexRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsImportIndexRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsNewIndexRoute,
    AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute:
      AuthenticatedOrgOrgSlugDepartmentDeptSlugJobsJobIdApplicationIdIndexRoute,
  }

const AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren =
  AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute._addFileChildren(
    AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute: typeof AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren
  AuthenticatedOrgOrgSlugIntegrationsIndexRoute: typeof AuthenticatedOrgOrgSlugIntegrationsIndexRoute
  AuthenticatedOrgOrgSlugTeamIndexRoute: typeof AuthenticatedOrgOrgSlugTeamIndexRoute
  AuthenticatedOrgOrgSlugWorkflowIndexRoute: typeof AuthenticatedOrgOrgSlugWorkflowIndexRoute
  AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute: typeof AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute
  AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute: typeof AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute
  AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute: typeof AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedOrgOrgSlugDepartmentDeptSlugRoute:
    AuthenticatedOrgOrgSlugDepartmentDeptSlugRouteWithChildren,
  AuthenticatedOrgOrgSlugIntegrationsIndexRoute:
    AuthenticatedOrgOrgSlugIntegrationsIndexRoute,
  AuthenticatedOrgOrgSlugTeamIndexRoute: AuthenticatedOrgOrgSlugTeamIndexRoute,
  AuthenticatedOrgOrgSlugWorkflowIndexRoute:
    AuthenticatedOrgOrgSlugWorkflowIndexRoute,
  AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute:
    AuthenticatedOrgOrgSlugIntegrationsLogicmelonIndexRoute,
  AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute:
    AuthenticatedOrgOrgSlugIntegrationsRecmanIndexRoute,
  AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute:
    AuthenticatedOrgOrgSlugIntegrationsTeamtailorIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CompleteRoute: CompleteRoute,
  LoginRoute: LoginRoute,
  DevErrorRoute: DevErrorRoute,
  InterviewTokenRoute: InterviewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
